import { toast } from 'react-hot-toast';
import { useQuery } from '@tanstack/react-query';

import { magazineService } from '@project/services';
import { MagazineListModel, MagazineSubscriptionModel } from './magazines.model';

const duration = { duration: 3000 };

export const useGetMagazinesQuery = (page?: number, per?: number) =>
  useQuery(['getMagazines', page, per], () => magazineService.getMagazines(page, per), {
    select: MagazineListModel,
    keepPreviousData: true,
    onError: () => toast.error('Could not fetch magazines', duration),
  });

export const useGetMagazineSubscriptionQuery = () =>
  useQuery(['getMagazineSubscription'], () => magazineService.getMagazineSubscription(), {
    select: MagazineSubscriptionModel,
    onError: () => toast.error('Could not fetch subscription', duration),
  });
